import React from 'react';
import SiteHtmlPage from '../components/siteContent/SiteHtmlPage';

const RefundPage = () => <SiteHtmlPage slug="refund" />;

export default RefundPage;
